<template>
    <div>
        <v-sheet class="px-6 pt-6">
            <div class="container">
                <div class="d-flex flex-wrap justify-space-between mb-8">
                    <div class="flex-1">
                        <div class="d-flex align-start justify-space-between">
                            <div class="mb-3">
                                <h5 class="mr-2 mb-0">
                                    {{ titleLabel }}
                                </h5>
                                <p class="text--disabled mb-0">Assign channels to media categories</p>
                            </div>
                        </div>
                        <div class="d-flex mb-2" v-if="!createMode && code">
                            <p class="ma-0 mr-8">
                                <span class="font-weight-medium">{{ code }}</span>
                            </p>
                        </div>
                    </div>
                    <div class="flex-1 text-right">
                        <v-btn class="ma-2" dark color="success" :loading="loading" @click="save">
                            <v-icon class="pr-2">mdi-content-save</v-icon>
                            Save
                        </v-btn>
                    </div>
                </div>
            </div>
        </v-sheet>
        <v-row justify="center">
            <v-col cols="10" md="5">
                <e-info-card title="Primary Fields" sub-title="">
                    <template slot="basic-info-slot">
                        <v-form v-model="editFormValid" ref="editForm">
                            <v-list>
                                <v-list-item v-if="!createMode">
                                    <v-list-item-content>
                                        <v-text-field
                                            label="Code"
                                            v-model="code"
                                            outlined
                                            readonly
                                            hide-details
                                        />
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-text-field
                                            label="Title"
                                            v-model="title"
                                            :rules="nameRules"
                                            :validate-on-blur="true"
                                        />
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-autocomplete
                                            label="Media Category"
                                            v-model="media_category_code"
                                            :items="mediaCategoryOptions"
                                            item-text="text"
                                            item-value="value"
                                            :rules="selectRules"
                                            :loading="categoryLoading"
                                            clearable
                                        ></v-autocomplete>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-textarea
                                            label="Description"
                                            v-model="description"
                                            auto-grow
                                            rows="2"
                                        />
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-form>
                    </template>
                </e-info-card>
            </v-col>
        </v-row>
        <v-snackbar
            v-model="snackbar"
            :timeout="4000"
            top
            tile
            :color="snackbarColor + ' -accent-2'"
        >
            {{ snackbarMessage }}
        </v-snackbar>
    </div>
</template>

<script>
import EInfoCard from '@/components/card/BasicInfoCard';
import {api} from "src/api/index";
import { fieldNotEmpty, fieldMinLength } from "src/core/vuetify-validators.js";

export default {
    metaInfo: {
        title: 'Media Channel Edit'
    },
    components: {
        EInfoCard
    },
    data() {
        return {
            code: '',
            title: '',
            description: '',
            media_category_code: '',
            mediaCategoryOptions: [],
            categoryLoading: false,
            crud_code: '',
            createMode: false,
            editFormValid: true,
            loading: false,
            snackbar: false,
            snackbarColor: 'green',
            snackbarMessage: '',
            error: '',
            nameRules: [
                fieldNotEmpty,
                (v) => fieldMinLength(v, 2)
            ],
            codeRules: [
                
            ],
            selectRules: [fieldNotEmpty]
        }
    },
    computed: {
        titleLabel() {
            return this.createMode ? 'Create Media Channel' : 'Edit Media Channel';
        }
    },
    created() {
        if(this.$route.params.code) {
            this.crud_code = this.$route.params.code;
            this.createMode = false;
        }
        else {
            this.createMode = true;
        }
    },
    async mounted() {
        await this.loadCategories();
        if(!this.createMode) {
            const rsp = await api.mediachannel.getOne(this.crud_code);
            if(rsp && rsp.data) {
                this.code = rsp.data.code;
                this.title = rsp.data.title;
                this.description = rsp.data.description;
                this.media_category_code = rsp.data.media_category_code || rsp.data.mediaCategory?.code;
            }
        }
    },
    methods: {
        async loadCategories() {
            this.categoryLoading = true;
            try {
                const rsp = await api.mediacategory.getAll();
                this.mediaCategoryOptions = rsp.data.map(i => ({value: i.code, text: i.title}));
            } finally {
                this.categoryLoading = false;
            }
        },
        async save() {
            this.error = '';
            await this.$refs.editForm.validate();
            if(!this.editFormValid) {
                this.snackbarColor = "red";
                this.snackbarMessage = "There are invalid fields.";
                this.snackbar = true;
                return;
            }
            this.loading = true;
            try {
                const payload = {
                    title: this.title,
                    description: this.description,
                    media_category_code: this.media_category_code
                };
                if(this.createMode) {
                    await api.mediachannel.create(payload);
                }
                else {
                    await api.mediachannel.update(this.crud_code, payload);
                }
                this.snackbarColor = "green";
                this.snackbarMessage = "Media channel saved successfully.";
                this.snackbar = true;
                if(this.createMode) {
                    this.$router.push({ name: 'adpoints-media-channels' });
                }
            } catch (error) {
                this.snackbarColor = "red";
                this.snackbarMessage = error.response?.data?.message || 'Failed to save media channel.';
                this.snackbar = true;
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>
